import Vue from "vue";
import store from "@/store";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import { loadVeeValidate } from "@/plugins/vee-validate";

// load validate language
loadVeeValidate(Cookies.get("ecs_admin_locale") || "vi");

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: Cookies.get("ecs_admin_locale") || "vi",
  messages: {}
});

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import(
      /* webpackChunkName: '' */ `@/lang/${locale}`
    );
    i18n.setLocaleMessage(locale, messages);
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale;
  }
}

(async function() {
  await loadMessages(store.getters["lang/locale"]);
})();

export default i18n;
